import { render, staticRenderFns } from "./keyboxPanel.vue?vue&type=template&id=bce78146&scoped=true&"
import script from "./keyboxPanel.vue?vue&type=script&lang=js&"
export * from "./keyboxPanel.vue?vue&type=script&lang=js&"
import style0 from "./keyboxPanel.vue?vue&type=style&index=0&id=bce78146&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce78146",
  null
  
)

export default component.exports